import { downloadCsv, loadDraftCsvColumns } from './storage';

export const DOMAIN_COLUMNS = [
  'domain',
  'product_name',
  'tagline',
  'description',
  'votes_count',
  'ph_url',
  'website',
  'launchedAt',
];

export const CONTACT_COLUMNS = [
  'email',
  'domain',
  'classification',
  'verification',
  'score',
  'savedAt',
  'launchedAt',
  'product_name',
  'tagline',
  'website',
];

export const DRAFT_COLUMNS = [
  'email',
  'first_name',
  'domain',
  'product_name',
  'tagline',
  'description',
  'votes_count',
  'ph_url',
  'website',
  'classification',
  'verification',
  'score',
  'subject',
  'finished_email',
  'pull_hypothesis',
];

function draftCell(draft, key) {
  if (key === 'finished_email') return draft.finished_email || draft.body || '';
  const value = draft[key];
  return value == null ? '' : value;
}

export function exportDomains(companies = []) {
  downloadCsv(
    `ph-domains-${new Date().toISOString().slice(0, 10)}.csv`,
    DOMAIN_COLUMNS,
    companies.map((row) => DOMAIN_COLUMNS.map((key) => row[key] ?? ''))
  );
}

export function exportContacts(contacts = []) {
  downloadCsv(
    `contacts-${new Date().toISOString().slice(0, 10)}.csv`,
    CONTACT_COLUMNS,
    contacts.map((row) => CONTACT_COLUMNS.map((key) => row[key] ?? ''))
  );
}

export function exportDraftEmails(drafts = [], columns) {
  const cols =
    Array.isArray(columns) && columns.length
      ? columns.filter((c) => DRAFT_COLUMNS.includes(c))
      : loadDraftCsvColumns(DRAFT_COLUMNS);
  if (!cols.length) return 0;
  downloadCsv(
    `outreach-emails-${new Date().toISOString().slice(0, 10)}.csv`,
    cols,
    drafts.map((row) => cols.map((key) => draftCell(row, key)))
  );
  return drafts.length;
}
